import { render, staticRenderFns } from "./TopMenu.vue?vue&type=template&id=57edfff2&scoped=true"
import script from "./TopMenu.vue?vue&type=script&lang=js"
export * from "./TopMenu.vue?vue&type=script&lang=js"
import style0 from "./TopMenu.vue?vue&type=style&index=0&id=57edfff2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57edfff2",
  null
  
)

export default component.exports